export * as actions from './actions';
export * as api from './api';

export const ROUTE_PREFIX = '/parkpass';

export const VehicleTypes = {
  'no-vehicle': 'No Vehicle',
  'personal-vehicle': 'Personal Vehicle',
  'rental-vehicle': 'Rental Vehicle'
};

export const Durations = {
  annual: {
    name: 'Annual',
    validLength: 'A Year',
    days: 365,
    endEndOfMonth: true
  },
  '10-day': {
    name: 'Ten Day',
    validLength: 'Ten Days',
    days: 10,
    endEndOfMonth: false
  },
  '7-day': {
    name: 'Week',
    validLength: 'A Week',
    days: 7,
    endEndOfMonth: false
  },
  '4-day': {
    name: 'Four day',
    validLength: 'Four Days',
    days: 4,
    endEndOfMonth: false
  },
  '3-day': {
    name: 'Three day',
    validLength: 'Three Days',
    days: 3,
    endEndOfMonth: false
  },
  '2-day': {
    name: 'Two day',
    validLength: 'Two Days',
    days: 2,
    endEndOfMonth: false
  }
};

export const Features = ['holder-info', 'vehicle-info', 'attendee-info', 'start-date'];

export const ReservationPointsOfSale = ['web', 'field'];
export const ReservationStatuses = ['pending', 'deleted', 'completed'];

export const ExpirationTypes = ['expired', 'refunded', 'voided'];

export default ROUTE_PREFIX;
